import React from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import RestrictedRoute from "./RestrictedRoute";

import {
  auth as authRoutes,
  landing as landingRoutes,
  dashboard as dashboardRoutes,
  data as dataRoutes,
  campaign as campaignRoutes,
  account as accountRoutes,
  administration as administrationRoutes,
} from "./index";

import DashboardLayout from "../layouts/Dashboard";
import LandingLayout from "../layouts/Landing";
import AuthLayout from "../layouts/Auth";
import Page404 from "../pages/auth/Page404";

import ScrollToTop from "../components/ScrollToTop";

const childRoutes = (Layout, routes) =>
  routes.map(({ isPrivate, restrictedToLevel, children, path, component: Component }, index) => {
    let RouteType = Route;
    if (isPrivate) {
      RouteType = PrivateRoute;
    }
    if (restrictedToLevel) {
      RouteType = RestrictedRoute;
    }

    return children ? (
      // Route item with children
      children.map(({ isPrivate, restrictedToLevel, path, component: Component }, index) => {
        let ChildRouteType = RouteType; // If child has more restrictive setting than parent
        if (isPrivate) {
          ChildRouteType = PrivateRoute;
        }
        if (restrictedToLevel) {
          ChildRouteType = RestrictedRoute;
        }
        return (
          <ChildRouteType
            exact
            key={index}
            path={path}
            restrictedToLevel={restrictedToLevel}
            render={(props) => (
              <Layout>
                <Component {...props} />
              </Layout>
            )}
          />
        );
      })
    ) : (
      // Route item without children
      <RouteType
        exact
        key={index}
        path={path}
        restrictedToLevel={restrictedToLevel}
        render={(props) => (
          <Layout>
            <Component {...props} />
          </Layout>
        )}
      />
    );
  });

const Routes = (props) => (
  <Router>
    <ScrollToTop>
      <Switch>
        <Redirect
          exact
          path="/"
          to={{ pathname: "/auth/sign-in", search: window.location.search }}
        />

        {childRoutes(LandingLayout, landingRoutes)}
        {childRoutes(DashboardLayout, dashboardRoutes)}
        {childRoutes(DashboardLayout, dataRoutes)}
        {childRoutes(DashboardLayout, campaignRoutes)}
        {childRoutes(DashboardLayout, accountRoutes)}
        {childRoutes(DashboardLayout, administrationRoutes)}
        {childRoutes(AuthLayout, authRoutes)}

        <Route
          render={() => (
            <AuthLayout>
              <Page404 />
            </AuthLayout>
          )}
        />
      </Switch>
    </ScrollToTop>
  </Router>
);

export default Routes;
